// extracted by mini-css-extract-plugin
module.exports = {"title":"CreateCustomModelModal-module__title--9gGMK","label":"CreateCustomModelModal-module__label--1YOgb"};